 export const categories = [
      {
        "value": 40,
        "heading": "Laptops"
      },
  
      {
        "value": 100,
        "heading": "Shoes"
      },
      {
        "value": 80,
        "heading": "Cameras"
      },
      {
        "value": 60,
        "heading": "Jeans"
      }
    ]
  
 export  const transaction = [
      {
        "id": "ksdnfkjsdfx",
        "amount": 4000,
        "quantity": 4,
        "discount": 300,
        "status": "Processing"
      },
      {
        "id": "sdsdssdsd",
        "amount": 5100,
        "quantity": 2,
        "discount": 900,
        "status": "Processing"
      },
      {
        "id": "sdsdcvsssdsd",
        "amount": 13000,
        "quantity": 91,
        "discount": 0,
        "status": "Shipped"
      },
      {
        "id": "dfddddfd",
        "amount": 2300,
        "quantity": 4,
        "discount": 2000,
        "status": "Processing"
      }
    ]
  
  